import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CursoLs from './pages/CursoLs';
import Obrigado from './pages/Obrigado';
import CursoLsV2 from './pages/CursoLsV2';
import BlogDashboard from './pages/BlogDashboard';
import PaymentFormPage from './pages/PaymentFormPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<CursoLs />} />
        <Route path='curso_lsv2' element={<CursoLsV2 />} />
        <Route path='obrigado' element={<Obrigado />} />
        <Route path='blog' element={<BlogDashboard />} />
        <Route path='pagamentos' element={<PaymentFormPage />} />
        {/*<Route path='dash_excel' element={<Excel/>}/>*/}
      </Routes>
    </BrowserRouter>
  )
};

export default App;
